import styled from 'styled-components';

export const CarouselOne = styled.div`
  overflow: hidden;
  position: relative;
  width: 100%;
`;

export const CarouselContainer = styled.div`
  width: 9282px;
  left: 0px;
  /* display: block; */
  transition: all 800ms ease 0s;
`;

export const PrevNxtWrap = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 45.5%;
  transform: translateY(-50%);
`;

export const Prev = styled.div`
  height: 2.5rem;
  width: 2.5rem;
  position: absolute;
  left: 1rem;
  cursor: pointer;
  background-color: #ffffff;
  padding: 0.5rem;
  border-radius: 50%;
  box-shadow: 0 0 3px #ccc;
`;

export const Nxt = styled.div`
  height: 2.5rem;
  width: 2.5rem;
  position: absolute;
  right: 1rem;
  cursor: pointer;
  background-color: #ffffff;
  padding: 0.5rem;
  border-radius: 50%;
  box-shadow: 0 0 3px #ccc;
`;

export const CarouselItemWrap = styled.div`
  width: 175px;
  @media (max-width: 768px) {
    width: 50%;
  }
`;

export const DateInfo = styled.div`
  color: #fff;
  font-size: 13px;
  font-weight: 400;
  padding-bottom: ${props => props.theme.spacing.custom(5)};
`;

export const FlightPrice = styled.div`
  color: #fff;
  font-size: 14px;
  border-bottom: 1px solid #fff;
`;

export const CarouselItem = styled.div`
  width: 100%;
  list-style: none;
  border-right: 1px solid #739bd0;
  padding: 10px 14px;
  text-align: center;
  text-decoration: none;
  background-color: #2276e2;
  font-family: ${props => props.theme.font.fontFamily};
  &:hover {
    background-color: #fff;
    ${DateInfo} {
      color: #666;
    }
    ${FlightPrice} {
      color: #f46913;
      border-bottom: 1px solid #f46913;
    }
  }
`;
